import React, { useState, useEffect } from "react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle scrolling effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={`fixed h-auto min-h-16 m-0 sm:m-2 top-0 left-0 right-0 bg-opacity-80 text-white p-2 sm:p-4 shadow-lg z-50 rounded-lg overflow-hidden backdrop-blur-sm transition-all duration-300 ${scrolled ? 'bg-opacity-80' : ''}`}>
      <div className="flex justify-between items-center px-3 sm:px-5 md:px-6 mx-auto">
        {/* Hamburger menu on small screens (left-aligned) */}
        <button 
          className="md:hidden text-white focus:outline-none"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
          </svg>
        </button>
        
        {/* Logo - centered on mobile, left-aligned on desktop */}
        <a href="#" className="text-base sm:text-lg md:text-xl font-bold md:ml-0 mx-auto md:mx-0"></a>
        
        {/* Empty div for spacing on mobile */}
        <div className="md:hidden w-6"></div>
        
        {/* Desktop menu */}
        <ul className="hidden md:flex space-x-2 lg:space-x-4 xl:space-x-8 flex-wrap justify-end">
          <li>
            <a
              href="#home"
              className="text-xs sm:text-sm md:text-base lg:text-lg px-2 xl:px-3 py-2 font-bold no-underline text-gray-300 hover:text-orange-600 transition duration-300 hover:outline hover:outline-2 hover:outline-white rounded-full text-center"
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#achievements"
              className="text-xs sm:text-sm md:text-base lg:text-lg px-2 xl:px-3 py-2 font-bold text-gray-300 no-underline hover:text-orange-600 transition duration-300 hover:outline hover:outline-2 hover:outline-white rounded-full text-center"
            >
              Achievements
            </a>
          </li>
          <li>
            <a
              href="#projects"
              className="text-xs sm:text-sm md:text-base lg:text-lg px-2 xl:px-3 py-2 font-bold text-gray-300 no-underline hover:text-orange-600 transition duration-300 hover:outline hover:outline-2 hover:outline-white rounded-full text-center whitespace-nowrap"
            >
              Professional Overview
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className="text-xs sm:text-sm md:text-base lg:text-lg px-2 xl:px-3 py-2 font-bold text-gray-300 no-underline hover:text-orange-600 transition duration-300 hover:outline hover:outline-2 hover:outline-white rounded-full text-center"
            >
              Contact
            </a>
          </li>
        </ul>
      </div>
      
      {/* Mobile menu dropdown with smooth transition */}
      <div 
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isMenuOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="py-2 mx-2 sm:mx-5 bg-gray-800 w-[200px] rounded-lg mt-2 overflow-hidden">
          <ul className="flex flex-col space-y-2 px-4">
            <li>
              <a
                href="#home"
                className="block text-xs sm:text-sm font-bold no-underline text-gray-300 hover:text-orange-600 transition duration-300 py-2"
                onClick={toggleMenu}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#achievements"
                className="block text-xs sm:text-sm font-bold no-underline text-gray-300 hover:text-orange-600 transition duration-300 py-2"
                onClick={toggleMenu}
              >
                Achievements
              </a>
            </li>
            <li>
              <a
                href="#projects"
                className="block text-xs sm:text-sm font-bold no-underline text-gray-300 hover:text-orange-600 transition duration-300 py-2"
                onClick={toggleMenu}
              >
                Professional Overview
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="block text-xs sm:text-sm font-bold no-underline text-gray-300 hover:text-orange-600 transition duration-300 py-2"
                onClick={toggleMenu}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;